import { useState } from 'react';
import { Link } from 'react-router-dom';
import { studies } from './studies/index.js';

function shareUrl(slug) {
  if (typeof window === 'undefined') return '';
  return `${window.location.origin}/study/${slug}`;
}

function StudyCard({ s }) {
  const [copied, setCopied] = useState(false);
  const copy = async () => {
    try { await navigator.clipboard.writeText(shareUrl(s.slug)); setCopied(true); setTimeout(() => setCopied(false), 1600); } catch { /* ignore */ }
  };
  return (
    <div className="scard" style={{ '--ca': s.accent }}>
      <div className="scard__top">
        <span className="scard__emoji" aria-hidden="true">{s.emoji}</span>
        <span className={`scard__status scard__status--${s.status}`}>{s.status === 'live' ? 'Live' : 'Draft'}</span>
      </div>
      <div className="scard__topic">{s.topic}</div>
      <h3 className="scard__title">{s.studyTitle}</h3>
      <div className="scard__meta">~{s.estMinutes} min · {s.mode === 'pre-post' ? 'Pre · Learn · Post' : 'Cross-sectional'}</div>
      <div className="scard__actions">
        <Link className="btn btn--card" to={`/study/${s.slug}`}>Open study →</Link>
        <button className="btn btn--ghostsm" onClick={copy}>{copied ? 'Copied ✓' : 'Copy link'}</button>
      </div>
    </div>
  );
}

export function StudyGrid() {
  return (
    <div className="study-grid">
      {studies.map((s) => <StudyCard key={s.slug} s={s} />)}
    </div>
  );
}
